import anime from 'animejs';

export default class Video {
  constructor(root) {
    this.root = root;
    this.isPlaying = false;

    this.iframeContainer = this.root.querySelector('.u-card__video-iframe');
    this.overlay = this.root.querySelector('.u-card__video-overlay');
    this.cover = this.root.querySelector('.u-card__cover');
    // this.content = this.root.querySelector('.u-card__content');
    this.src = this.iframeContainer.dataset.src;

    this.bind();
  }

  bind() {
    this.play = this.play.bind(this);
    // this.stop = this.stop.bind(this);

    // this.content.addEventListener('click', this.stop);
    this.overlay.addEventListener('click', this.play);
  }

  play() {
    if (this.isPlaying) {
      return;
    }


    const tl = anime.timeline();

    tl
    .add({
      targets: this.overlay,
      opacity: [1, 0]
    })
    .add({
      targets: this.cover,
      translateY: [0, -30],
      easing: 'easeOutQuad',
      duration: 300,
      complete: () => {
        // this.root.classList.add('u-card--video--play');
        this.root.classList.add('is-playing');
      }
    })
    .add({
      targets: this.cover,
      translateY: [-30, 0],
      easing: 'easeInQuad',
      duration: 300,
    });

    const iframe = this.createIframe(this.src);
    this.iframeContainer.appendChild(iframe);
    this.isPlaying = true;
  }

  // stop(e) {
  //   if (!this.isPlaying) {
  //     return;
  //   }

  //   e.preventDefault();
  //   e.stopPropagation();

  //   this.root.classList.remove('u-card--video--play');
  //   this.root.classList.remove('is-playing');

  //   this.overlay.style.display = 'flex';
  //   this.overlay.style.opacity = 0;

  //   anime({
  //     targets: this.overlay,
  //     opacity: 1,
  //     complete: () => {
  //       this.iframeContainer.innerHTML = '';
  //     }
  //   });

  //   this.isPlaying = false;
  // }

  createIframe(src) {
    const iframe = document.createElement('iframe');
          iframe.frameBorder = 0;
          iframe.allowFullscreen = true;
          iframe.src = src;

    return iframe;
  }
}
